export default __webpack_public_path__ + "static/media/logo.081d489a.png";